<template>
  <div class="container">
    <HeadingOne class="-margin-md">ログインID設定</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="3" type="localid"></MainWizard>
    </WizardGroup>

    <NoticeBox class="-success">
      <NoticeHeader>
        <h3 class="heading">ログインIDの設定が完了しました。</h3>
      </NoticeHeader>
      <NoticeBody
        >「ログイン画面へ」を押下いただき、ログインIDでログインください。</NoticeBody
      >
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main" router-name="ce002"> ログイン画面へ </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";

export default {
  name: "Ce005",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ログインID設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法",
    });
  },
  data() {
    return {};
  },
  mounted() {
    localStorage.removeItem("local_login_data");
    localStorage.removeItem("local_id_data");
  },
};
</script>

<style scoped></style>
